import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/navbar";

import opportunitiesImg from "../assets/cost optimization dashboard.png";
import anomaliesImg     from "../assets/anomalies Dashboard.jpg";
import savingsImg       from "../assets/savings dashboard.jpg";
import mainDashImg      from "../assets/maindashboard.jpg";

const SPECS = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='48' height='28' viewBox='0 0 48 28'%3E%3Crect x='1' y='4' width='18' height='18' rx='9' ry='9' fill='none' stroke='%231a1a1a' stroke-width='2.5'/%3E%3Crect x='29' y='4' width='18' height='18' rx='9' ry='9' fill='none' stroke='%231a1a1a' stroke-width='2.5'/%3E%3Cpath d='M19 13 L29 13' stroke='%231a1a1a' stroke-width='2.5' stroke-linecap='round'/%3E%3Cpath d='M1 13 L0 8' stroke='%231a1a1a' stroke-width='2' stroke-linecap='round'/%3E%3Cpath d='M47 13 L48 8' stroke='%231a1a1a' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E`;

const css = `
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,400&display=swap');
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0;scroll-behavior:smooth}
body{
  background:#fafafa;
  background-image:linear-gradient(rgba(0,0,0,0.045) 1px,transparent 1px),linear-gradient(90deg,rgba(0,0,0,0.045) 1px,transparent 1px);
  background-size:32px 32px;
  font-family:'DM Sans',sans-serif;
  color:#111;
  cursor:url("${SPECS}") 24 14,auto;
}
a,button{cursor:url("${SPECS}") 24 14,pointer}

@keyframes fadeUp{from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:translateY(0)}}
.d0{animation:fadeUp .5s .00s ease both}
.d1{animation:fadeUp .5s .10s ease both}
.d2{animation:fadeUp .5s .20s ease both}
.d3{animation:fadeUp .5s .30s ease both}
.reveal{opacity:0;transform:translateY(16px);transition:opacity .6s ease,transform .6s ease}
.reveal.in{opacity:1;transform:translateY(0)}

.back{display:inline-flex;align-items:center;gap:8px;font-size:11px;font-weight:600;letter-spacing:.1em;text-transform:uppercase;color:#aaa;background:none;border:none;padding:0;transition:color .15s}
.back:hover{color:#111}
.mlabel{font-size:11px;font-weight:500;color:#aaa;letter-spacing:.08em;display:block;margin-bottom:10px}
.lh{font-size:clamp(26px,4.5vw,44px);font-weight:800;letter-spacing:-0.03em;line-height:1.1;color:#111}
.bt{font-size:15px;color:#555;line-height:1.85}
.hl{background:#fde047;padding:0 3px;border-radius:2px}
.bq{border-left:3px solid #111;padding-left:20px;font-size:16px;font-weight:600;color:#111;line-height:1.5}
.div{border:none;border-top:1px solid #e8e8e8;margin:0}
.prog{transition:width .3s}
.sc-img{width:100%;display:block;box-shadow:0 8px 32px rgba(0,0,0,0.10)}

/* number dot */
.ndot{width:24px;height:24px;border-radius:50%;background:#111;color:#fff;font-size:10px;font-weight:800;display:flex;align-items:center;justify-content:center;flex-shrink:0;margin-top:1px}

::-webkit-scrollbar{width:3px}
::-webkit-scrollbar-thumb{background:#ddd;border-radius:4px}

@media(max-width:900px){
  .four-col{grid-template-columns:repeat(2,1fr)!important}
}
@media(max-width:640px){
  .sc-row{flex-direction:column!important}
  .two-col{grid-template-columns:1fr!important}
  .three-col{grid-template-columns:1fr!important}
  .four-col{grid-template-columns:1fr!important}
  main{padding:20px 16px 64px!important}
  .lh{font-size:clamp(22px,6vw,30px)!important}
}
`;

function useReveal() {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current; if (!el) return;
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { el.classList.add("in"); obs.disconnect(); }
    }, { threshold:.06 });
    obs.observe(el); return () => obs.disconnect();
  }, []);
  return ref;
}
function Sec({ children, style }) {
  const r = useReveal();
  return <section ref={r} className="reveal" style={{ marginBottom:88,...style }}>{children}</section>;
}
function useWidth() {
  const [w, setW] = useState(typeof window !== "undefined" ? window.innerWidth : 1200);
  useEffect(() => {
    const fn = () => setW(window.innerWidth);
    window.addEventListener("resize", fn);
    return () => window.removeEventListener("resize", fn);
  }, []);
  return w;
}

/* ── Screen + side annotations (same pattern as CS1) ── */
function ScreenSection({ src, alt, imgLeft=true, bg="#f5f5f5", annotations=[] }) {
  const w = useWidth();
  const isMobile = w < 640;
  const imgEl = (
    <div style={{ flexShrink:0, width:isMobile?"100%":"48%", background:bg, padding:isMobile?"20px":"32px 28px", display:"flex", alignItems:"center", justifyContent:"center" }}>
      <img src={src} alt={alt} className="sc-img" />
    </div>
  );
  const annEl = (
    <div style={{ flex:1, minWidth:0, padding:isMobile?"20px":"32px 36px", display:"flex", flexDirection:"column", gap:20 }}>
      {annotations.map((a,i) => (
        <div key={i} style={{ display:"flex", gap:14, alignItems:"flex-start" }}>
          <div className="ndot">{i+1}</div>
          <div>
            <p style={{ fontSize:13, fontWeight:700, color:"#111", marginBottom:4 }}>{a.label}</p>
            <p style={{ fontSize:12.5, color:"#666", lineHeight:1.65 }}>{a.body}</p>
          </div>
        </div>
      ))}
    </div>
  );
  return (
    <div className="sc-row" style={{ display:"flex", gap:0, alignItems:"stretch", border:"1px solid #e8e8e8", background:"#fff", flexDirection: isMobile?"column": imgLeft?"row":"row-reverse" }}>
      {imgLeft ? <>{imgEl}{annEl}</> : <>{annEl}{imgEl}</>}
    </div>
  );
}

/* ── IA / Structure diagram ── */
function IADiagram() {
  const modules = [
    { name:"Dashboard", items:["Savings Overview","Cost Trends","Anomaly Alerts","Quick Actions"] },
    { name:"Opportunities", items:["Ranked by potential savings","Filter by service/region","Drill into detail","Take action"] },
    { name:"Anomalies", items:["Spike detection","Baseline deviation","Resource-level drill","Root cause hints"] },
    { name:"Savings Tracker", items:["Realised savings","Actions taken","Estimated vs actual","Export reports"] },
    { name:"Reports", items:["Scheduled reports","Cost breakdown","By team / service","CSV/PDF export"] },
    { name:"Settings", items:["Cloud account connect","Alert thresholds","Team access","Notification prefs"] },
  ];
  return (
    <div style={{ border:"1px solid #e8e8e8", background:"#e8e8e8", display:"grid", gridTemplateColumns:"1fr", gap:1 }}>
      <div style={{ background:"#111", padding:"16px 24px" }}>
        <p style={{ fontSize:13, fontWeight:700, color:"#fff" }}>CloudEvolve — Cost Optimization Platform</p>
      </div>
      <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:1 }} className="three-col">
        {modules.map((m,i) => (
          <div key={i} style={{ background:"#fff", padding:"18px 20px" }}>
            <p style={{ fontSize:12, fontWeight:800, color:"#111", marginBottom:10 }}>{m.name}</p>
            {m.items.map((it,j) => (
              <p key={j} style={{ fontSize:11.5, color:"#888", lineHeight:1.7, paddingLeft:10, borderLeft:"1.5px solid #e8e8e8" }}>{it}</p>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

/* ── User flow ── */
function UserFlow() {
  const steps = [
    { step:"Land on Dashboard", role:"Any user", insight:"Savings potential shown first — not raw spend" },
    { step:"Review Opportunities", role:"DevOps / FinOps", insight:"Ranked by $ savings, not $ cost" },
    { step:"Drill into detail", role:"DevOps", insight:"Resource-level breakdown, usage charts" },
    { step:"Take action", role:"DevOps", insight:"One-click remediation or export to ticket" },
    { step:"Check Anomalies", role:"FinOps", insight:"Spike vs baseline, per-service view" },
    { step:"Track Savings", role:"Finance / Manager", insight:"Realised vs estimated, over time" },
  ];
  return (
    <div style={{ border:"1px solid #e8e8e8", background:"#e8e8e8", display:"grid", gridTemplateColumns:"1fr", gap:1 }}>
      <div style={{ background:"#fafafa", padding:"14px 20px", display:"grid", gridTemplateColumns:"2fr 1.5fr 2fr" }}>
        {["Step","Primary Role","Design Insight"].map(h => (
          <p key={h} style={{ fontSize:10, fontWeight:700, letterSpacing:".12em", textTransform:"uppercase", color:"#aaa" }}>{h}</p>
        ))}
      </div>
      {steps.map((s,i) => (
        <div key={i} style={{ background:"#fff", padding:"16px 20px", display:"grid", gridTemplateColumns:"2fr 1.5fr 2fr", gap:8, alignItems:"center" }}>
          <div style={{ display:"flex", alignItems:"center", gap:10 }}>
            <div style={{ width:20, height:20, borderRadius:"50%", background:"#111", color:"#fff", fontSize:9, fontWeight:800, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>{i+1}</div>
            <p style={{ fontSize:13, fontWeight:600, color:"#111" }}>{s.step}</p>
          </div>
          <p style={{ fontSize:12.5, color:"#888" }}>{s.role}</p>
          <p style={{ fontSize:12.5, color:"#555", lineHeight:1.5 }}>{s.insight}</p>
        </div>
      ))}
    </div>
  );
}

/* ── Awareness → Investigation → Action → Measurement process label ── */
function ProcessLabel() {
  const stages = ["Awareness", "Investigation", "Action", "Measurement"];
  return (
    <div style={{ display:"flex", alignItems:"center", flexWrap:"wrap", gap:8, marginBottom:28 }}>
      {stages.map((s,i) => (
        <div key={s} style={{ display:"flex", alignItems:"center", gap:8 }}>
          <span style={{ fontSize:11, fontWeight:700, letterSpacing:".08em", textTransform:"uppercase", color:"#111", background:"#fff", border:"1px solid #e8e8e8", borderRadius:999, padding:"6px 14px" }}>{s}</span>
          {i < stages.length-1 && (
            <svg width="16" height="10" viewBox="0 0 16 10" fill="none"><path d="M1 5h13M9 1l5 4-5 4" stroke="#bbb" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
          )}
        </div>
      ))}
    </div>
  );
}

/* ═══ MAIN ═══ */
export default function CaseStudy2() {
  const [prog, setProg] = useState(0);
  const navigate = useNavigate();
  const w = useWidth();
  const isMobile = w < 640;

  useEffect(() => {
    const fn = () => { const el = document.documentElement; setProg((el.scrollTop/(el.scrollHeight-el.clientHeight))*100); };
    window.addEventListener("scroll",fn); return ()=>window.removeEventListener("scroll",fn);
  },[]);

  return (
    <div style={{ background:"#fafafa", minHeight:"100vh", backgroundImage:"linear-gradient(rgba(0,0,0,0.045) 1px,transparent 1px),linear-gradient(90deg,rgba(0,0,0,0.045) 1px,transparent 1px)", backgroundSize:"32px 32px" }}>
      <style>{css}</style>
      <div style={{ position:"fixed",top:0,left:0,right:0,height:3,background:"rgba(0,0,0,0.07)",zIndex:100 }}>
        <div className="prog" style={{ height:"100%",background:"#111",width:`${prog}%` }} />
      </div>

      <Navbar />

      <main style={{ padding: isMobile?"20px 16px 64px":"40px 6vw 100px" }}>

        {/* back */}
        <div className="d0" style={{ marginBottom:40 }}>
          <button className="back" onClick={()=>navigate("/")}>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M9 2L4 7l5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
            Back
          </button>
        </div>

        {/* ══ HERO ══ */}
        <section style={{ marginBottom:80 }}>
          <div className="d0" style={{ display:"flex",gap:8,flexWrap:"wrap",marginBottom:20 }}>
            {["Web App","FinOps","Enterprise SaaS","B2B"].map(t=>(
              <span key={t} style={{ fontSize:11,fontWeight:500,color:"#888",background:"#f0f0f0",borderRadius:999,padding:"3px 12px" }}>{t}</span>
            ))}
          </div>
          <h1 className="d1 lh" style={{ marginBottom:20 }}>
            Cloud Cost Optimization Platform
          </h1>
         <p className="d2 bt" style={{ marginBottom:36 }}>
  DevOps, FinOps, and Finance teams were overwhelmed by complex cloud cost data but lacked clarity on what to optimize first.
  I designed the end-to-end user experience for a FinOps SaaS platform that transforms raw cloud spend into <span className="hl">prioritized, actionable savings opportunities</span>, helping teams move from analysis to action with confidence.
</p>
          <div className="d3" style={{ display:"flex",flexWrap:"wrap",gap:40,paddingTop:24,borderTop:"1px solid #e8e8e8" }}>
            {[{l:"Product",v:"CloudEvolve / CostFixer Module"},{l:"Platform",v:"Web Application"},{l:"Duration",v:"4 Months"},{l:"Role",v:"UI/UX Designer — End-to-end"},{l:"Users",v:"DevOps • FinOps • Finance Teams"}].map(m=>(
              <div key={m.l}>
                <p style={{ fontSize:10,fontWeight:600,letterSpacing:".14em",textTransform:"uppercase",color:"#bbb",marginBottom:4 }}>{m.l}</p>
                <p style={{ fontSize:13,fontWeight:600 }}>{m.v}</p>
              </div>
            ))}
          </div>
        </section>

        {/* hero screens banner */}
        <Sec>
          <div style={{ background:"#111",padding:isMobile?"20px":"32px 28px 28px" }}>
            <p style={{ fontSize:10,fontWeight:600,letterSpacing:".2em",textTransform:"uppercase",color:"#444",textAlign:"center",marginBottom:24 }}>4 core views · 1 FinOps system</p>
            <div style={{ display:"grid",gridTemplateColumns:isMobile?"1fr 1fr":"repeat(4,1fr)",gap:10 }}>
              {[mainDashImg, opportunitiesImg, anomaliesImg, savingsImg].map((s,i)=>(
                <img key={i} src={s} alt="" style={{ width:"100%",display:"block" }} />
              ))}
            </div>
          </div>
        </Sec>

        {/* ══ PRODUCT HIGHLIGHTS ══ */}
        <Sec>
          <span className="mlabel">Product Highlights</span>
          <div style={{ display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:1,border:"1px solid #e8e8e8",background:"#e8e8e8" }} className="four-col">
            {[
              { num:"3", title:" Primary User Roles", sub:"DevOps • FinOps • Finance" },
              { num:"6", title:"Core Platform Modules", sub:"Dashboard • Opportunities • Anomalies • Savings • Reports • Settings" },
              { num:"Multi-Cloud", title:"AWS • Azure • Google Cloud", sub:"Single experience across providers" },
              { num:"Multi-account", title:"Account • Region • Service • Resource", sub:"Consolidated visibility with drill-down analytics"},
            ].map((m,i)=>(
              <div key={i} style={{ padding:"24px 20px",background:"#fff" }}>
                <p style={{ fontSize:"clamp(32px,4vw,48px)",fontWeight:800,letterSpacing:"-0.04em",lineHeight:1,marginBottom:10,color:"#111" }}>{m.num}</p>
                <p style={{ fontSize:13,fontWeight:600,marginBottom:4,color:"#111" }}>{m.title}</p>
                <p style={{ fontSize:12,color:"#aaa" }}>{m.sub}</p>
              </div>
            ))}
          </div>
        </Sec>

        {/* ══ PROJECT CONSTRAINTS (NEW) ══ */}
        <Sec>
          <span className="mlabel">Project Constraints</span>
          <div style={{ display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:1,border:"1px solid #e8e8e8",background:"#e8e8e8" }} className="four-col">
            {[
              { t:"No direct customer access", b:"I designed using stakeholder workshops and domain expertise." },
              { t:"Complex cloud terminology", b:"I simplified technical concepts for different user groups." },
              { t:"Multiple user personas", b:"I balanced DevOps, FinOps, and Finance priorities." },
              { t:"Enterprise-scale data", b:"I designed for large datasets across multiple cloud providers." },
            ].map((c,i)=>(
              <div key={i} style={{ padding:"22px 20px",background:"#fff" }}>
                <p style={{ fontSize:13,fontWeight:700,marginBottom:8 }}>{c.t}</p>
                <p style={{ fontSize:13,color:"#777",lineHeight:1.65 }}>{c.b}</p>
              </div>
            ))}
          </div>
        </Sec>

        <hr className="div" style={{ marginBottom:80 }} />

        {/* ══ CONTEXT ══ */}
        <Sec>
          <span className="mlabel">Context</span>
          <h2 className="lh" style={{ marginBottom:16 }}>Cloud costs were growing. Nobody knew where to start fixing them.</h2>
          <p className="bt" style={{ marginBottom:36 }}>
            As an AWS Premium Partner, our engineering and finance teams supported existing cloud customers whose spend grew every quarter.
            I identified that existing tools only showed <span className="hl">what was spent — not what was fixable</span>.
            The product was shaped from real customer pain points gathered by cloud architects and product managers. The data existed. The clarity didn't.
          </p>
          <div style={{ display:"grid",gridTemplateColumns:"1fr 1fr",gap:1,border:"1px solid #e8e8e8",background:"#e8e8e8",marginBottom:32 }} className="two-col">
            {[
              { label:"No visibility into fixable waste", body:"Dashboards showed total spend by service. High spend doesn't mean fixable spend — teams couldn't distinguish necessary cost from waste." },
              { label:"No prioritisation", body:"Too many alerts and insights surfaced simultaneously. Engineers couldn't tell what to fix first or which actions would have the most impact." },
              { label:"No clear action path", body:"Even when a problem was identified, there was no structured workflow to act on it. Insights died in spreadsheets and Slack threads." },
              { label:"Three teams, three different needs", body:"DevOps needed resource-level detail. FinOps needed trend analysis. Finance needed savings summaries. One tool tried to serve all three — and served none well." },
            ].map((f,i)=>(
              <div key={i} style={{ padding:"22px 22px",background:"#fff" }}>
                <p style={{ fontSize:13,fontWeight:700,marginBottom:8 }}>{f.label}</p>
                <p style={{ fontSize:13,color:"#777",lineHeight:1.65 }}>{f.body}</p>
              </div>
            ))}
          </div>
          <div className="bq">
            "We know we're overspending on cloud. We just don't know what's safe to cut, what's a spike vs a trend, and where to even begin."
          </div>
        </Sec>

        {/* ══ USERS ══ */}
        <Sec>
          <span className="mlabel">Users</span>
          <h2 className="lh" style={{ marginBottom:16 }}>Three roles. Three different mental models.</h2>
          <p className="bt" style={{ marginBottom:32 }}>
            I mapped three distinct user types before designing anything.
            Each had a <span className="hl">different primary question</span> when opening the platform — and the design had to answer all three.
          </p>
          <div style={{ display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:1,border:"1px solid #e8e8e8",background:"#e8e8e8" }} className="three-col">
            {[
              { role:"DevOps Engineer", kpi:"Issue Resolution Time", q:'"Which specific resource is causing this cost spike?"', goal:"Resource-level detail, actionable remediation", pain:"Drowning in raw cost data with no resource-level context" },
              { role:"FinOps Analyst", kpi:"Cloud Cost Optimization", q:'"Is this spend a trend or a one-time anomaly?"', goal:"Trend analysis, anomaly detection, forecasting", pain:"No way to distinguish normal growth from fixable waste" },
              { role:"Finance Manager", kpi:"Budget Tracking & Savings", q:'"How much have we actually saved this quarter?"', goal:"Savings summaries, ROI reporting, team accountability", pain:"No visibility into the impact of optimisation actions taken" },
            ].map((u,i)=>(
              <div key={i} style={{ background:"#fff",padding:"22px 20px",borderTop:"2px solid #111" }}>
                <p style={{ fontSize:12,fontWeight:800,color:"#111",marginBottom:10 }}>{u.role}</p>
                <p style={{ fontSize:15,color:"#333",lineHeight:1.6,fontStyle:"italic",marginBottom:14 }}>{u.q}</p>
                <p style={{ fontSize:12,fontWeight:600,color:"#111",marginBottom:4 }}>Goal</p>
                <p style={{ fontSize:12.5,color:"#666",marginBottom:10,lineHeight:1.5 }}>{u.goal}</p>
                <p style={{ fontSize:12,fontWeight:600,color:"#111",marginBottom:4 }}>Pain point</p>
                <p style={{ fontSize:12.5,color:"#777",lineHeight:1.5,marginBottom:14 }}>{u.pain}</p>
                <div style={{ borderTop:"1px solid #f0f0f0", paddingTop:12 }}>
                  <p style={{ fontSize:10,fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:"#bbb",marginBottom:3 }}>Primary KPI</p>
                  <p style={{ fontSize:12.5,fontWeight:600,color:"#111" }}>{u.kpi}</p>
                </div>
              </div>
            ))}
          </div>
        </Sec>

        <hr className="div" style={{ marginBottom:80 }} />

        {/* ══ IA ══ */}
        <Sec>
          <span className="mlabel">Information Architecture</span>
          <h2 className="lh" style={{ marginBottom:16 }}>Six modules. One question answered per module.</h2>
          <p className="bt" style={{ marginBottom:12 }}>
            I structured the platform so each module answers one primary user question.
            No module tries to do everything. <span className="hl">Clarity of purpose drives usability.</span>
          </p>
          <p style={{ fontSize:13, color:"#999", fontStyle:"italic", marginBottom:32 }}>
            Each module answers one primary user question instead of exposing backend system complexity.
          </p>
          <IADiagram />
        </Sec>

        {/* ══ USER FLOW ══ */}
        <Sec>
          <span className="mlabel">User Flow</span>
          <h2 className="lh" style={{ marginBottom:16 }}>From surfacing waste → to recovering money.</h2>
          <p className="bt" style={{ marginBottom:24 }}>
            The core user journey is linear by design. Each step <span className="hl">builds on the previous one</span> — discovery leads to detail, detail leads to action, action leads to accountability.
          </p>
          <ProcessLabel />
          <UserFlow />
        </Sec>

        <hr className="div" style={{ marginBottom:80 }} />

        {/* ══ KEY DESIGN DECISION ══ */}
        <Sec>
          <span className="mlabel">Key Design Decision</span>
          <h2 className="lh" style={{ marginBottom:16 }}>Lead with savings, not spend.</h2>
          <p className="bt" style={{ marginBottom:32 }}>
            The most consequential decision in this product wasn't a layout or a component.
            It was deciding <span className="hl">which number to show first</span>. Users don't open a dashboard to understand everything — they open it to know what to do first.
          </p>

          {/* 3-option comparison */}
          <div style={{ display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:1,border:"1px solid #e8e8e8",background:"#e8e8e8",marginBottom:32 }} className="three-col">
            {[
              { tag:"✗ Rejected", label:"Lead with spend breakdown", body:"Rich charts showing spend by service, region, team. Full picture first — then identify problems." },
              { tag:"✗ Rejected", label:"Ranked by highest cost", body:"List resources by what they cost — highest spenders first. Simple and data-honest." },
              { tag:"✓ Chosen", label:"Lead with potential savings", body:"Surface what teams can actually fix, ranked by how much they'd save. Raw cost accessible — never the hero metric.", chosen:true },
            ].map((o,i)=>(
              <div key={i} style={{ padding:"22px 20px",background: o.chosen?"#111":"#fff" }}>
                <p style={{ fontSize:11,fontWeight:700,color: o.chosen?"#555":"#bbb",marginBottom:8 }}>{o.tag}</p>
                <p style={{ fontSize:14,fontWeight:700,color: o.chosen?"#fff":"#111",marginBottom:8 }}>{o.label}</p>
                <p style={{ fontSize:13,color: o.chosen?"#aaa":"#777",lineHeight:1.6 }}>{o.body}</p>
              </div>
            ))}
          </div>

          <div style={{ display:"grid",gridTemplateColumns:"1fr 1fr",gap:1,border:"1px solid #e8e8e8",background:"#e8e8e8",marginBottom:24 }} className="two-col">
            <div style={{ padding:"24px 24px",background:"#fff",borderTop:"3px solid #111" }}>
              <p style={{ fontSize:11,fontWeight:700,letterSpacing:".12em",textTransform:"uppercase",color:"#aaa",marginBottom:12 }}>The insight that drove this</p>
              <p style={{ fontSize:15,fontWeight:700,color:"#111",lineHeight:1.5,marginBottom:12 }}>Raw cost data triggers blame, not action.</p>
              <p style={{ fontSize:14,color:"#555",lineHeight:1.75 }}>
                When a DevOps team sees "$180K spent on idle instances," the first instinct is to ask who provisioned them — not to fix them.
                I reframed the same number as <span className="hl">"$180K in recoverable savings"</span> to shift the conversation from accountability to opportunity.
                Savings framing spoke to stakeholders and engineers simultaneously.
              </p>
            </div>
            <div style={{ padding:"24px 24px",background:"#fff",borderTop:"3px solid #111" }}>
              <p style={{ fontSize:11,fontWeight:700,letterSpacing:".12em",textTransform:"uppercase",color:"#aaa",marginBottom:12 }}>Why each audience responded differently</p>
              <div style={{ display:"flex",flexDirection:"column",gap:14 }}>
                {[
                  { label:"Finance Managers", body:"Evaluate tools by what they recover, not what they surface. Savings framing made the product immediately legible to decision-makers." },
                  { label:"DevOps Engineers", body:"Respond to clear, scoped tasks. 'Here's what's fixable and how much you'd save' — not 'here's everything you spent.'" },
                  { label:"FinOps Analysts", body:"Need to justify their team's existence with ROI. Savings recovered = their impact made visible." },
                ].map((r,i)=>(
                  <div key={i} style={{ paddingBottom:12,borderBottom:i<2?"1px solid #f0f0f0":"none" }}>
                    <p style={{ fontSize:13,fontWeight:700,marginBottom:3 }}>{r.label}</p>
                    <p style={{ fontSize:12.5,color:"#666",lineHeight:1.55 }}>{r.body}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div style={{ padding:"20px 24px",borderLeft:"3px solid #111",background:"#fff",border:"1px solid #e8e8e8",borderLeft:"3px solid #111" }}>
            <p className="bq" style={{ fontSize:14 }}>In data-heavy products, the most important design decision is often not a UI pattern — it's a framing decision. What you lead with determines how users feel about the product before they've clicked anything.</p>
          </div>
        </Sec>

        {/* ══ SCREEN 01 — Main Dashboard ══ */}
        <Sec>
          <span className="mlabel">Design Decision 01</span>
          <h2 className="lh" style={{ marginBottom:16 }}>The dashboard — savings first, spend second.</h2>
          <p className="bt" style={{ marginBottom:28 }}>
            The dashboard exists for awareness, not analysis. It answers one question: <span className="hl">"Where should I start?"</span>
            Detailed investigation happens later, in Opportunities and Anomalies. Potential savings, ranked by opportunity size, is the first number every user sees here.
          </p>
          <ScreenSection src={mainDashImg} alt="Main Dashboard" imgLeft={true} bg="#f0f4ff"
            annotations={[
              { label:"Savings potential at the top", body:"The primary metric is not 'total spend' — it's 'total recoverable savings'. Users immediately understand what they can act on." },
              { label:"Opportunities ranked by impact", body:"Resources are sorted by potential savings, not by cost. High-spend necessary items don't crowd out fixable waste." },
              { label:"Quick action surface", body:"One-click remediation options available directly from the dashboard — no drilling required for common actions." },
              { label:"Anomaly alerts integrated", body:"Spend spikes appear inline with opportunities. Users see both what to fix now and what to investigate — without switching context." },
            ]}
          />
        </Sec>

        {/* ══ SCREEN 02 — Opportunities ══ */}
        <Sec>
          <span className="mlabel">Design Decision 02</span>
          <h2 className="lh" style={{ marginBottom:16 }}>Opportunities — actionable by design, not by accident.</h2>
          <p className="bt" style={{ marginBottom:28 }}>
            The original brief asked for a "cost insights" view. I pushed back — insights without actions are just expensive reports.
            I designed every opportunity card to <span className="hl">end in an action, not a report</span>.
          </p>
          <ScreenSection src={opportunitiesImg} alt="Opportunities Dashboard" imgLeft={false} bg="#f0fff5"
            annotations={[
              { label:"Savings amount — not cost amount", body:"Each card leads with '$X recoverable' — not '$X spent'. Users see the opportunity, not the blame." },
              { label:"Effort vs impact matrix signal", body:"Quick wins (high savings, low effort) are visually distinguished from complex optimisations. Users can triage in seconds." },
              { label:"Filter by service, team, region", body:"FinOps analysts can segment opportunities by ownership. DevOps can filter to their specific resource types." },
              { label:"'Take action' CTA per opportunity", body:"Every card ends in an action — resize, delete, rightsize, export to ticket. Insight to action in one click." },
            ]}
          />
        </Sec>

        {/* ══ SCREEN 03 — Anomalies ══ */}
        <Sec>
          <span className="mlabel">Design Decision 03</span>
          <h2 className="lh" style={{ marginBottom:16 }}>Anomalies — spikes vs trends, instantly distinguishable.</h2>
          <p className="bt" style={{ marginBottom:12 }}>
            The hardest problem in cloud cost monitoring isn't detecting anomalies — it's knowing whether a spike is
            <span className="hl"> a one-time event or the start of a trend</span>. I designed the anomalies view to answer that question before the user has to ask it.
          </p>
          <p style={{ fontSize:13, color:"#999", marginBottom:32, lineHeight:1.7 }}>
            <strong style={{ color:"#555" }}>Opportunity</strong> — a known optimization opportunity.{" "}
            <strong style={{ color:"#555" }}>Anomaly</strong> — unexpected behavior requiring investigation.
          </p>
          <ScreenSection src={anomaliesImg} alt="Anomalies Dashboard" imgLeft={true} bg="#fff8f0"
            annotations={[
              { label:"Spike vs baseline clearly separated", body:"Each anomaly shows the current reading against a rolling baseline. The gap is the story — not the raw number." },
              { label:"Severity ranking — not chronological", body:"Anomalies are ranked by deviation severity, not by when they occurred. Most urgent always at top." },
              { label:"Resource-level attribution", body:"Each anomaly links to the specific service and resource responsible. No more 'EC2 costs spiked' — which EC2, which team." },
              { label:"One-click investigation path", body:"'Why did this happen?' leads to a resource timeline showing what changed — deployments, config changes, scaling events." },
            ]}
          />
        </Sec>

        {/* ══ SCREEN 04 — Savings Tracker ══ */}
        <Sec>
          <span className="mlabel">Design Decision 04</span>
          <h2 className="lh" style={{ marginBottom:16 }}>Savings tracker — turning action into accountability.</h2>
          <p className="bt" style={{ marginBottom:28 }}>
            Without a savings tracker, optimisation is invisible. Engineers take action and never see the result.
            Finance can't report impact. I designed the tracker to <span className="hl">close the feedback loop</span> —
            helping teams measure optimization impact and building trust in the platform's recommendations over time.
          </p>
          <ScreenSection src={savingsImg} alt="Savings Tracking" imgLeft={false} bg="#f0fdf4"
            annotations={[
              { label:"Realised vs estimated savings", body:"Actual savings after action compared to the estimate shown at the opportunity stage. Builds trust in the platform's projections over time." },
              { label:"Savings over time — trend view", body:"Finance managers can see month-over-month savings growth. The platform justifies its own ROI." },
              { label:"Actions taken — full audit trail", body:"Every optimisation action is logged with who took it, when, and what the outcome was. Accountability without blame." },
              { label:"Export for finance reporting", body:"One-click export to CSV/PDF for quarterly finance reviews. The insight doesn't die in the platform — it travels to where decisions are made." },
            ]}
          />
        </Sec>

        <hr className="div" style={{ marginBottom:80 }} />

        {/* ══ CONSTRAINTS & TRADEOFFS ══ */}
        <Sec>
          <span className="mlabel">Constraints & Tradeoffs</span>
          <h2 className="lh" style={{ marginBottom:16 }}>What we ran into — and the calls we made.</h2>
          <p className="bt" style={{ marginBottom:36 }}>
            This product had <span className="hl">no direct user research</span>. No user interviews, no usability testing, no field observation.
            I made every design decision through stakeholder alignment, domain expertise, and first-principles thinking about how FinOps teams actually work.
          </p>

          {/* main constraint card */}
          <div style={{ display:"grid",gridTemplateColumns:"1fr 1fr",gap:1,border:"1px solid #e8e8e8",background:"#e8e8e8",marginBottom:1 }} className="two-col">
            <div style={{ padding:"28px 26px",background:"#fff",borderTop:"3px solid #111" }}>
              <p style={{ fontSize:11,fontWeight:700,letterSpacing:".12em",textTransform:"uppercase",color:"#aaa",marginBottom:12 }}>Primary constraint</p>
              <p style={{ fontSize:24,fontWeight:800,color:"#111",lineHeight:1.25,marginBottom:14,letterSpacing:"-0.02em" }}>No direct user access. I designed entirely from stakeholder input and domain research.</p>
              <p style={{ fontSize:14,color:"#666",lineHeight:1.75 }}>
                No user interviews were conducted before or during the design process. I had business requirements, stakeholder conversations, and knowledge of how FinOps teams operate — no observed user behaviour.
                Stakeholder reviews became the validation mechanism in the absence of direct user research.
              </p>
            </div>
            <div style={{ background:"#fff",padding:"28px 26px",borderTop:"3px solid #111" }}>
              <p style={{ fontSize:11,fontWeight:700,letterSpacing:".12em",textTransform:"uppercase",color:"#aaa",marginBottom:16 }}>How I compensated</p>
              <div style={{ display:"flex",flexDirection:"column",gap:14 }}>
                {[
                  { label:"Stakeholder as proxy user", body:"I ran weekly design reviews with product and engineering stakeholders who came from FinOps backgrounds. Their reactions served as user signal." },
                  { label:"Domain-driven decisions", body:"I researched how FinOps teams actually structure their work — the FOCUS framework, cloud cost allocation patterns, and how DevOps and Finance differ in their mental models." },
                  { label:"Estimated savings as validation proxy", body:"I used estimated savings impact as a proxy for user value — if the potential savings surfaced were accurate and actionable, the design was working." },
                ].map((c,i)=>(
                  <div key={i} style={{ paddingBottom:12,borderBottom:i<2?"1px solid #f0f0f0":"none" }}>
                    <p style={{ fontSize:13,fontWeight:700,color:"#111",marginBottom:4 }}>{c.label}</p>
                    <p style={{ fontSize:12.5,color:"#666",lineHeight:1.6 }}>{c.body}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Tradeoffs table */}
          <div style={{ border:"1px solid #e8e8e8",background:"#e8e8e8",display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:1 }} className="three-col">
            <div style={{ padding:"14px 20px",background:"#fafafa" }}>
              <p style={{ fontSize:10,fontWeight:700,color:"#aaa",letterSpacing:".12em",textTransform:"uppercase" }}>Tradeoff</p>
            </div>
            <div style={{ padding:"14px 20px",background:"#fafafa" }}>
              <p style={{ fontSize:10,fontWeight:700,color:"#aaa",letterSpacing:".12em",textTransform:"uppercase" }}>What I gave up</p>
            </div>
            <div style={{ padding:"14px 20px",background:"#fafafa" }}>
              <p style={{ fontSize:10,fontWeight:700,color:"#aaa",letterSpacing:".12em",textTransform:"uppercase" }}>Why it was worth it</p>
            </div>
            {[
              { t:"Lead with savings, not spend", g:"Finance analysts who prefer raw spend as default view. Cost breakdown moved one click deeper — accessible but not primary.", w:"Users immediately understand where to start. First-session clarity was more valuable than power-user flexibility." },
              { t:"Savings framing over cost transparency", g:"Some users felt savings estimates were 'optimistic' before actions were taken. Trust in projections had to be earned over time.", w:"ROI language drives adoption. A product that shows $2.4M in recoverable savings gets budget approval; one that shows $8M in spend does not." },
              { t:"Prioritised clarity over feature depth", g:"Advanced filtering, custom dashboards, and multi-account comparison were deferred to v2.", w:"A platform with 6 focused features used daily beats one with 20 features used never. Adoption required immediate value — not eventual power." },
              { t:"No user research pre-launch", g:"Design decisions couldn't be validated against actual user behaviour before delivery.", w:"Stakeholder iteration was the validation mechanism. Every screen was reviewed by domain experts who had lived the FinOps problem." },
            ].map((row,i)=>(
              <>
                <div key={`a${i}`} style={{ padding:"18px 20px",background:"#fff" }}><p style={{ fontSize:13,fontWeight:600,color:"#333",lineHeight:1.5 }}>{row.t}</p></div>
                <div key={`b${i}`} style={{ padding:"18px 20px",background:"#fff" }}><p style={{ fontSize:13,color:"#888",lineHeight:1.6 }}>{row.g}</p></div>
                <div key={`c${i}`} style={{ padding:"18px 20px",background:"#fff" }}><p style={{ fontSize:13,color:"#555",lineHeight:1.6 }}>{row.w}</p></div>
              </>
            ))}
          </div>
        </Sec>

        <hr className="div" style={{ marginBottom:80 }} />

        {/* ══ LEARNINGS ══ */}
        <Sec>
          <span className="mlabel">Retrospective</span>
          <h2 className="lh" style={{ marginBottom:32 }}>What this project taught me.</h2>
          {[
            { t:"In data products, framing is the design", b:"The most impactful decision wasn't a layout or a component — it was choosing to show savings instead of spend. Framing determines how users feel before they click anything." },
            { t:"Clarity consistently outperforms complexity", b:"Every time I added another chart or filter, adoption intent dropped in stakeholder reviews. Every time I removed something, it improved. Restraint is the skill." },
            { t:"Designing without user research requires extraordinary stakeholder alignment", b:"When I couldn't validate with users, I validated with domain experts. I ran weekly design reviews and treated every pushback as a user signal." },
            { t:"Action-oriented UX reduces cognitive load measurably", b:"Replacing 'here's your data' with 'here's what to do about it' was the single change that most improved perceived usability in every stakeholder review." },
            { t:"What I would do differently next time", b:"If I were redesigning this today, I would validate assumptions earlier through usability testing, introduce AI-assisted optimization recommendations, and personalize dashboards based on user roles." },
          ].map((item,i,arr)=>(
            <div key={i} style={{ display:"flex",gap:24,padding:"24px 0",borderBottom:i<arr.length-1?"1px solid #e8e8e8":"none",alignItems:"flex-start" }}>
              <p style={{ fontSize:13,fontWeight:700,color:"#ccc",flexShrink:0,minWidth:28 }}>0{i+1}</p>
              <div>
                <p style={{ fontSize:15,fontWeight:700,color:"#111",marginBottom:6 }}>{item.t}</p>
                <p style={{ fontSize:14,color:"#666",lineHeight:1.8 }}>{item.b}</p>
              </div>
            </div>
          ))}
        </Sec>

        {/* ── NEXT ── */}
        <div onClick={()=>navigate("/case-study/digiyatra")}
          style={{ padding:"32px 32px",border:"1px solid #e8e8e8",background:"#fff",cursor:"pointer",transition:"border-color .2s" }}
          onMouseEnter={e=>{e.currentTarget.style.borderColor="#111"}}
          onMouseLeave={e=>{e.currentTarget.style.borderColor="#e8e8e8"}}>
          <p style={{ fontSize:10,fontWeight:600,letterSpacing:".16em",textTransform:"uppercase",color:"#aaa",marginBottom:8 }}>Next case study</p>
          <h3 style={{ fontSize:20,fontWeight:800,letterSpacing:"-0.02em" }}>Seamless Airport Travel Experience →</h3>
          <p style={{ fontSize:13,color:"#aaa",marginTop:6 }}>DigiYatra · Mobile App · B2C</p>
        </div>

      </main>
    </div>
  );
}